<template>
    <div id="edit-blog-post">
        <div class="edit-blog-post-wrap">
            <div class="edit-blog-post-pad">
                <div class="edit-blog-post-title-input-wrap">
                    <div class="edit-blog-post-title">Title</div>
                    <input type="text" v-model="currentBlogpost.title" class="edit-blog-input">
                </div>
                <div id="editor" class="edit-blog-post-body-input-wrap">

                </div>
                <div class="flex">
                    <div class="edit-blog-post-publish-date">
                        <div class="add-paragraph-button" v-on:click="handlePublishDateClick()">Select Publish Date</div>
                        <datetime type="datetime" v-model="currentBlogpost.datepublished" class="theme-red" input-class="edit-blog-input-short hidden" format="yyyy-MM-dd HH:mm"></datetime>
                        <div class="edit-blog-post-publish-date-preview">{{ displayDate(currentBlogpost.datepublished) }}</div>
                    </div>

                    <div class="edit-blog-post-image">
                        <input type="file" id="fileElem" accept="image/*" style="display:none" @change="previewImage()">
                        <div v-on:click="handleImageClick()" class="edit-blog-post-image-button add-paragraph-button">
                            Select Image
                        </div>
                        <div id="image-preview"></div>
                    </div>
                </div>
                <div class="edit-blog-post-buttons">
                    <div v-on:click="finalizePost(0); $emit('finish')" class="edit-blog-post-save-hidden add-paragraph-button">Save</div>
                    <div v-on:click="finalizePost(1); $emit('finish')" class="edit-blog-post-publish add-paragraph-button">Publish</div>
                    <div v-on:click="showDeletePostModal()" class="edit-blog-post-save-hidden add-paragraph-button red-button">Delete</div>
                </div>
            </div>
        </div>
        <div v-if="deleteModal" id="delete-post-modal-container">
            <div class="delete-post-modal-content">
                <div class="delete-post-modal-title">
                    Are you sure you want to delete this post?
                </div>
                <div v-on:click="closeDeletePostModal()" class="delete-post-modal-button delete-button-blue">Cancel</div>
                <div v-on:click="deletePost(); $emit('finish')" class="delete-post-modal-button delete-button-red">Delete</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment'
import Quill from 'quill'
import 'quill/dist/quill.core.js' 
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
const fb = require('../firebaseConfig.js')

export default {
    components: {
        datetime: Datetime
    },
    props: ['blogpost'],
    data() {
        return {
            quill: null,
            currentBlogpost: {
                id: "",
                title: "",
                datecreated: "",
                datepublished: "",
                image: "",
                body: "",
                visibility: ""
            },
            deleteModal: false
        }
    },
    methods: {
        htmlToEditor: function() {
            this.quill.clipboard.dangerouslyPasteHTML(this.currentBlogpost.body);
        },
        handlePublishDateClick: function() {
            document.getElementsByClassName("vdatetime-input")[0].click()
        },
        handleImageClick: function() {
            document.getElementById("fileElem").click()
        },
        previewImage: function() {
            var file = document.getElementById("fileElem").files[0]
            if (file) {
                var reader = new FileReader()
                reader.onload = function (e) {
                    var img = new Image();
                    img.src = e.target.result
                    document.getElementById('image-preview').innerHTML = ''
                    document.getElementById('image-preview').appendChild(img)
                }
                reader.readAsDataURL(file)
            } else {
                document.getElementById('image-preview').innerHTML = ''
                var oldimg = new Image();
                oldimg.src = this.currentBlogpost.image
                document.getElementById('image-preview').appendChild(oldimg)
            }
            this.currentBlogpost.image = "new"
            
        },
        uploadImage: function() {
            const cloudName = 'dkq6zer55';
            const unsignedUploadPreset = 'yrdba4rz';
            
            var myData = this
            var file = document.getElementById("fileElem").files[0]
            var url = `https://api.cloudinary.com/v1_1/${cloudName}/upload`
            var xhr = new XMLHttpRequest()
            var fd = new FormData()
            xhr.open('POST', url, false)
            xhr.setRequestHeader('X-Requested-With', "XMLHttpRequest")

            xhr.onreadystatechange = function() {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    var response = JSON.parse(xhr.responseText)
                    var url = response.secure_url

                    myData.currentBlogpost.image = url
                }
            }

            fd.append('upload_preset', unsignedUploadPreset)
            fd.append('tags', 'blog_image_upload')
            fd.append('file', file)
            xhr.send(fd)
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY -  HH:mm')
            } else {
                return "Please select a date"
            }
        },
        finalizePost: function(visibility) {
            this.currentBlogpost.body = this.quill.container.firstChild.innerHTML
            if (this.blogpost.image != this.currentBlogpost.image && this.currentBlogpost.image) {
                this.uploadImage()
            }
            this.currentBlogpost.visibility = visibility
            this.currentBlogpost.datecreated = new Date().toISOString()
            this.editPost()
        },
        editPost: function() {
            var new_title = this.currentBlogpost.title
            var new_body = this.currentBlogpost.body
            var new_image
            if (this.currentBlogpost.image != "new") {
                new_image = this.currentBlogpost.image
            } else {
                new_image = this.blogpost.image
            }
            var new_datepublished = this.currentBlogpost.datepublished
            var new_visibility = this.currentBlogpost.visibility

            fb.db.collection("blogs").doc(this.blogpost.id).update({
                title: new_title,
                body: new_body,
                image: new_image,
                datepublished: new_datepublished,
                visibility: new_visibility
            })
            
            /* fb.blogsCollection.add({
                title: this.blogpost.title,
                body: this.blogpost.body,
                image: this.blogpost.image,
                datecreated: this.blogpost.datecreated,
                datepublished: this.blogpost.datepublished,
                visibility: this.blogpost.visibility
            }).then(ref => {
                ref
                // ROUTE TO ALL BLOG POSTS
            }) */
        },
        showDeletePostModal: function() {
            this.deleteModal = true
        },
        closeDeletePostModal: function() {
            this.deleteModal = false
        },
        deletePost: function() {
            fb.db.collection("blogs").doc(this.blogpost.id).delete();
        }
    },
    created: function(){
        this.currentBlogpost.id = this.blogpost.id
        this.currentBlogpost.title = this.blogpost.title
        this.currentBlogpost.datecreated = this.blogpost.datecreated
        this.currentBlogpost.datepublished = this.blogpost.datepublished
        this.currentBlogpost.image = this.blogpost.image
        this.currentBlogpost.body = this.blogpost.body
        this.currentBlogpost.visibility = this.blogpost.visibility
        
    },
    mounted: function() {
        var toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons

            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [ 'link', 'image', 'video' ],          // add's image support
            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'align': [] }],
        ];
        var quill = new Quill('#editor', {
            modules: {
                toolbar: toolbarOptions
            },
            theme: 'snow'
        });
        this.quill = quill
        this.htmlToEditor()
        this.previewImage()
    }
}
</script>

<style>
#edit-blog-post {
    position: relative;
}
.edit-blog-post-wrap {
    width: 90%;
    margin:auto;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: white;
    text-align: left;
}
.edit-blog-post-pad {
    padding:20px 50px;
}
.edit-blog-post-title-input-wrap {
    width:100%;
    margin-bottom: 10px;
}
.edit-blog-post-title {
    font-size: 20px;
}
.edit-blog-input {
    width: 100%;
    font-family: 'oswald';
    border: none;
    padding:10px;
    font-size: 16px;
    border: 1px solid #ccc;
    resize: none;
}
.edit-blog-input-short {
    font-family: 'oswald';
    border: none;
    padding:10px;
    font-size: 16px;
    border: 3px solid rgb(245, 240, 240);
    resize: none;
    text-align: center;
}
.ql-editor {
    min-height: 200px;
}
.edit-paragraph-button {
    margin: 0 auto;
    height: 50px;
    width: 150px;
    background-color: rgb(69, 144, 194);
    line-height: 50px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 20px;
}
.edit-blog-post-publish-date {
    width:50%;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    border-right: 3px solid rgb(245, 240, 240);
}
.edit-blog-post-publish-date-preview {
    font-size: 26px;
    line-height: 200px;
}

.edit-blog-post-image {
    margin-top: 20px;
    width:50%;
    height:200px;
}
#image-preview {
    margin: 0 auto;
    height:200px;
    width: 356px;
    background-color: #f0f0f0;
}
#image-preview img {
    display:block;
    margin: 0 auto;
    max-height: 200px;
    max-width: 356px;
}
.flex {
    display:flex;
    justify-content: space-between;
}
.edit-blog-post-buttons {
    position: relative;
    margin:0;
    margin-top: 200px;
    height:100px;
    text-align: right;
}
.edit-blog-post-buttons * {
    float:right;
    margin-left: 15px;
}
#delete-post-modal-container {
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(0,0,0,0.4);
}
.delete-post-modal-content {
    position:relative;
    width: 30%;
    height: 200px;
    margin: 15% auto;
    background-color: white;
    padding: 2rem;
}
.delete-post-modal-title {
    height:70%;
    font-size: 26px;
    margin-top: 20px;
}
.delete-post-modal-button {
    display: block;
    height: 50px;
    width: 150px;
    line-height: 50px;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    margin-left: 10px;
    bottom: 1rem;
    right: 1rem;
    float:right;
}
.delete-button-red {
    background-color: #B33B3B;
}
.delete-button-blue {
    background-color: rgb(69, 144, 194);
}

.red-button {
    background-color: #B33B3B;
}
.hidden {
    display:none;
}
.theme-red .vdatetime-popup__header,
.theme-red .vdatetime-calendar__month__day--selected > span > span,
.theme-red .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #B33B3B;
}
</style>